import NumberHelper from "../../helpers/numbers";
import MobileHelper from "../../helpers/mobile";

const allUserTabel = (users) => {
  users.map((user) => {
    user.usr_mobile = NumberHelper.toPersianNum(user.usr_mobile);
    user.usr_created_at = NumberHelper.toPersianNum(user.usr_created_at);
    user.usr_updated_at = NumberHelper.toPersianNum(user.usr_updated_at);
    user.usr_last_login_at = NumberHelper.toPersianNum(user.usr_last_login_at);
    if (user.usr_mobile) {
      user.usr_mobile = MobileHelper.formatMobile(user.usr_mobile);
    }

    return user;
  });

  return users;
};

export default {
  allUserTabel,
};
